import React, {Component} from "react"
import PropTypes from "prop-types"
import {Button, Col, Glyphicon, Modal, Row} from 'react-bootstrap'
import * as Enums from "../../utils/enums"
import {AllergyStatus, AnimalKindLabel, CastrationStatus, EventType, ExamType, ExitType, SexType, TreatmentType, WeightUnitLabel} from "../../utils/enums";
import {Date} from "../../utils";
import {formatQuaran} from "../../utils/format";

const checkbox = (checked, label) => {
	if (checked) {
		return <span className={'print-checkbox'}>&#9746; <strong>{label}</strong></span>
	}
	return <span className={'print-checkbox'}>&#9744; <span>{label}</span></span>
}

const printExams = (examsPage, skip, min = 5) => {
	let items = [];
	if (examsPage && examsPage.items && examsPage.items.length) {
		items = examsPage.items.filter(item => item.examDoctor && !(skip && skip.indexOf(item) >= 0)).reverse();
	}
	const rows = [];
	for (let i = 0; i < Math.max(items.length, min); i++) {
		const item = items[i];
		rows.push(<tr key={i}>
			<th>Datum</th>
			<td>{item && Date.formatDate(item.examDate)}</td>
			<th>Popis</th>
			<td colSpan={5}>{item && item.eventDesc}</td>
			<th colSpan={2}>Veterinární lékař</th>
			<td>{item && item.examDoctor}</td>
		</tr>)
	}
	return rows;
}

const printTreatments = (treatmentsPage, min = 3) => {
	let items = [];
	if (treatmentsPage && treatmentsPage.items && treatmentsPage.items.length) {
		items = treatmentsPage.items.reverse();
	}
	const rows = [];
	for (let i = 0; i < Math.max(items.length, min); i++) {
		const item = items[i];
		rows.push(<tr key={i}>
			<th>Název</th>
			<td>{item && item.treatTitle}</td>
			<th>Četnost</th>
			<td>{item && item.treatDosage}</td>
			<th>Množství</th>
			<td>{item && item.treatAmount}</td>
			<th>Od-do</th>
			{item && (item.treatType === TreatmentType.CONT || item.treatType === TreatmentType.SHORT)
				? <td>{item.treatFrom ? (item.treatTo
					? <span>{Date.formatDate(item.treatFrom)} - {Date.formatDate(item.treatTo)}</span>
					: Date.formatDate(item.treatFrom)) : null}</td>
				: <td>
					{item && item.treatDate && Date.formatDate(item.treatDate)}
				</td>
			}
			<th>Poznámky</th>
			<td>{item && item.treatReason}</td>
		</tr>)
	}
	return rows;
}

const printEventsPar = (eventsPage, enums, min = 5) => {
	let itemsExt = [];
	let itemsInt = [];
	if (eventsPage && eventsPage.items && eventsPage.items.length) {
		itemsExt = eventsPage.items.filter(item => item.eventType === EventType.PE).reverse();
		itemsInt = eventsPage.items.filter(item => item.eventType === EventType.PI).reverse();
	}
	const rows = [];
	for (let i = 0; i < Math.max(Math.max(itemsExt.length, itemsInt.length), min); i++) {
		const itemExt = itemsExt[i];
		const itemInt = itemsInt[i];
		rows.push(<tr key={i + 'a'}>
			<th rowSpan={2}>Datum</th>
			<td rowSpan={2}>{itemExt && Date.formatDate(itemExt.eventDate)}</td>
			<th>Název</th>
			<td>{itemExt ? itemExt.eventDesc + (itemExt.pillsAmount ? ', ' + itemExt.pillsAmount : '') : null}</td>
			<th rowSpan={2}>Datum</th>
			<td rowSpan={2}>{itemInt && Date.formatDate(itemInt.eventDate)}</td>
			<th>Název</th>
			<td>{itemInt ? itemInt.eventDesc + (itemInt.pillsAmount ? ', ' + itemInt.pillsAmount : '') : null}</td>
		</tr>);
		rows.push(<tr key={i + 'b'}>
			<th>Ošetřil</th>
			<td>{itemExt && (itemExt.eventDoctor || (itemExt.eventBy && Enums.getEnumTitle(enums, 'user', itemExt.eventBy)))}</td>
			<th>Ošetřil</th>
			<td>{itemInt && (itemInt.eventDoctor || (itemInt.eventBy && Enums.getEnumTitle(enums, 'user', itemInt.eventBy)))}</td>
		</tr>);
		rows.push(<tr key={i + 'c'}>
			<th>Forma</th>
			<td colSpan={3}>
				{enums['methodExt'] && enums['methodExt'].items && enums['methodExt'].items.map((m) => {
					return checkbox(itemExt && itemExt.methodId === 1 * m.value, m.label);
				})}
			</td>
			<th>Forma</th>
			<td colSpan={3}>
				{enums['methodInt'] && enums['methodInt'].items && enums['methodInt'].items.map((m) => {
					return checkbox(itemInt && itemInt.methodId === 1 * m.value, m.label);
				})}
			</td>
		</tr>);
	}
	return rows;
}

const printEventsVa = (eventsPage, enums, min = 8) => {
	let items = [];
	if (eventsPage && eventsPage.items && eventsPage.items.length) {
		items = eventsPage.items.filter(item => item.eventType === EventType.VA).reverse();
	}
	const rows = [];
	for (let i = 0; i < Math.max(items.length, min); i++) {
		const item = items[i];
		let vaName = null;
		let vaDesc = null;
		if (item && item.vaccineId && enums['vaccine'] && enums['vaccine'].items) {
			const v = enums['vaccine'].items.filter(v => v.value * 1 === item.vaccineId)[0];
			vaName = v ? v.label : null;
			if (vaName && vaName.indexOf('(')) {
				vaDesc = vaName.split('(')[1].replace(')', '');
				vaName = vaName.split('(')[0];
			}
		}
		rows.push(<tr key={i + 'a'}>
			<th rowSpan={2}>Datum</th>
			<td rowSpan={2}>{item && Date.formatDate(item.eventDate)}</td>
			<th rowSpan={2}>Název</th>
			<td rowSpan={2}>{vaName}</td>
			<th>Vakcinace proti</th>
			<td style={{fontSize: "70%"}}>{vaDesc}</td>
			<th>Vakcinoval</th>
			<td>{item && (item.eventDoctor ? item.eventDoctor : (item.eventBy && Enums.getEnumTitle(enums, 'user', item.eventBy)))}</td>
			<th>Poznámka</th>
			<td>{item && item.eventNote}</td>
		</tr>);
		rows.push(<tr key={i + 'b'}>
			<th>Šarže</th>
			<td>{null}</td>
			<th>Přeočkování</th>
			<td>{item && item.expireTo ? (item.expireFrom
				? <span>{Date.formatDate(item.expireFrom)} - {Date.formatDate(item.expireTo)}</span>
				: Date.formatDate(item.expireTo)) : null}</td>
			<th>Reakce</th>
			<td>{null}</td>
		</tr>);
	}
	return rows;
}


class DogPrintZK extends Component {

	render() {
		const {
			dog,
			intakesPage, exitsPage, examsPage, eventsPage, treatmentsPage,
			modal, enums
		} = this.props;

		if (!dog) {
			return null;
		}

		const weightItem = dog.weight && dog.weight.weightItems && dog.weight.weightItems.length
			? dog.weight.weightItems[dog.weight.weightItems.length - 1]
			: null;

		let intake = null;
		if (intakesPage && intakesPage.items && intakesPage.items.length > 0) {
			intake = intakesPage.items[0];
		}
		let exit = null;
		if (exitsPage && exitsPage.items && exitsPage.items.length > 0 && exitsPage.items[0].exitType === ExitType.DE) {
			exit = exitsPage.items[0];
		}
		let intExam = null;
		if (examsPage && examsPage.items && examsPage.items.length > 0) {
			intExam = examsPage.items.filter((exam) => exam.examType === ExamType.INT)[0];
		}
		let vetExam = null;
		if (examsPage && examsPage.items && examsPage.items.length > 0) {
			vetExam = examsPage.items.filter((exam) => exam.examType === ExamType.VET)[0];
		}

		let chEvent = null;
		let caEvent = null;
		let boxEvents = [];
		let desEvents = [];
		if (eventsPage && eventsPage.items && eventsPage.items.length > 0) {
			chEvent = eventsPage.items.filter((event) => event.eventType === EventType.CH)[0];
			caEvent = eventsPage.items.filter((event) => event.eventType === EventType.CA)[0];
			boxEvents = eventsPage.items.filter((event) => event.eventType === EventType.OT && event.eventDesc && event.eventDesc.indexOf('z boxu') >= 0);
			desEvents = eventsPage.items.filter((event) => event.eventType === EventType.OT && event.eventDesc && event.eventDesc.indexOf('ezinfekce') >= 0);
		}

		return <Modal onHide={modal.onHide} show={true} className={'print-horizontal'}>
			<Modal.Header>
				<Modal.Title>{dog.name} - Zdravotní karta</Modal.Title>
			</Modal.Header>

			<Modal.Body className="dog-print-wrapper">
				<div className="dog-print">
					<table cellPadding={0} cellSpacing={0}>
						<thead>
						<tr>
							<td><h1>ZDRAVOTNÍ KARTA</h1></td>
						</tr>
						</thead>
						<tbody>
						<tr>
							<td>
								<table cellPadding={0} cellSpacing={0} border={1}>
									<colgroup>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'12.5%'}/>
										<col width={'12.5%'}/>
										<col width={'12.5%'}/>
										<col width={'12.5%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'12.5%'}/>
									</colgroup>
									<thead>
									<tr>
										<th colSpan={11}>Identifikační údaje zvířete</th>
									</tr>
									</thead>
									<tbody>
									<tr>
										<th>Jméno</th>
										<td colSpan={4}>{dog.name}</td>
										<th>Číslo čipu</th>
										<td colSpan={5}>{dog.chipNumber}</td>
									</tr>
									<tr>
										<th colSpan={2}>Druh zvířete</th>
										<td>{AnimalKindLabel[dog.animalKind]}</td>
										<th>Datum narození</th>
										<td>{Date.formatDateOrYear(dog.birthDate)}</td>
										<th>Evidenční číslo</th>
										<td colSpan={2}>{dog.dogNumber || ''}</td>
										<th colSpan={2}>Číslo tetování</th>
										<td>{dog.isTat ? dog.tatNumber : ''}</td>
									</tr>
									<tr>
										<th>Plemeno</th>
										<td colSpan={2}>{Enums.getEnumTitle(enums, 'breed', dog.breedId)}</td>
										<th>Váha</th>
										<td>{weightItem ? ("" + weightItem.weightValue).replace('.', ',') + ' ' + WeightUnitLabel[weightItem.weightUnit] : null}</td>
										<th>Datum přijetí</th>
										<td colSpan={3}>{intake ? Date.formatDate(intake.intakeAt) : null}</td>
										<th>Čas přijetí</th>
										<td>{intake ? Date.format(intake.intakeAt, "HH:mm") : null}</td>
									</tr>
									<tr>
										<th colSpan={2}>Popis vzhledu</th>
										<td colSpan={3}>{dog.visualDesc}</td>
										<th>Karanténa</th>
										<td colSpan={5}>{formatQuaran(dog, true)}</td>
									</tr>
									<tr>
										<th colSpan={2}>Potravinová alergie</th>
										<td colSpan={3}>
											<div>
												{checkbox(dog.allergyStatus === AllergyStatus.NO, 'Ne')}
												{checkbox(dog.allergyStatus === AllergyStatus.YES, 'Ano')}
												{checkbox(!(dog.allergyStatus === AllergyStatus.YES || dog.allergyStatus === AllergyStatus.NO), 'Nezjištěno')}
											</div>
										</td>
										<th rowSpan={2}>Exitus</th>
										<td rowSpan={2} className={'text-center'}>{checkbox(!exit, 'NE')}</td>
										<td rowSpan={2} className={'text-center'}>{checkbox(exit, 'ANO')}</td>
										<th>Datum</th>
										<td colSpan={2}>{exit && Date.formatDate(exit.exitAt)}</td>
									</tr>
									<tr>
										<th colSpan={2}>Kastrace</th>
										<td colSpan={2}>
											{checkbox(dog.castrationStatus === CastrationStatus.NO, 'Ne')}
											{checkbox(dog.castrationStatus === CastrationStatus.YES, 'Ano')}
											{checkbox(!(dog.castrationStatus === CastrationStatus.YES || dog.castrationStatus === CastrationStatus.NO), 'Nezjištěno')}
										</td>
										<td>
											{checkbox(dog.sex === SexType.M, '♂')}
											{checkbox(dog.sex === SexType.F, '♀')}
										</td>
										<th>Důvod</th>
										<td colSpan={2}>{exit && exit.exitDesc}</td>
									</tr>
									</tbody>
									<thead>
									<tr>
										<th colSpan={11}>Zdravotní záznamy</th>
									</tr>
									</thead>
									<tbody>
									<tr>
										<th colSpan={5}>Subjektivní zhodnocení stavu pracovníkem útulku</th>
										<th colSpan={6}>Vyšetření stavu veterinárním lékařem</th>
									</tr>
									<tr>
										<td colSpan={5} className={'print-multi-rows'}>
											<div>{intExam && intExam.examResult}</div>
										</td>
										<td colSpan={6} className={'print-multi-rows'}>
											<div>{vetExam && vetExam.examResult}</div>
										</td>
									</tr>
									<tr>
										<th colSpan={2}>Stav zhodnotil</th>
										<td>{intExam && Enums.getEnumTitle(enums, 'user', intExam.examBy)}</td>
										<th>Datum</th>
										<td>{intExam && Date.formatDate(intExam.examDate)}</td>
										<th>Stav zhodnotil</th>
										<td colSpan={3}>{vetExam && vetExam.examDoctor}</td>
										<th>Datum</th>
										<td>{vetExam && Date.formatDate(vetExam.examDate)}</td>
									</tr>
									</tbody>
									<thead>
									<tr>
										<th colSpan={11}>Provedené úkony</th>
									</tr>
									</thead>
									<tbody>
									<tr>
										<th className={'print-head'} colSpan={2}>Čipování</th>
										<th>Datum čipování</th>
										<td>{chEvent && Date.formatDate(chEvent.eventDate)}</td>
										<th>Čip aplikoval</th>
										<td colSpan={2}>{chEvent && chEvent.eventBy && Enums.getEnumTitle(enums, 'user', chEvent.eventBy)}</td>
										<th>Exp. Čipu</th>
										<td colSpan={3}>{chEvent && chEvent.expireTo && Date.formatDate(chEvent.expireTo)}</td>
									</tr>
									<tr>
										<th className={'print-head'} colSpan={2}>Kastrace</th>
										<th>Datum kastrace</th>
										<td>{caEvent && Date.formatDate(caEvent.eventDate)}</td>
										<th>Veterinární lékař</th>
										<td colSpan={2}>{caEvent && caEvent.eventDoctor}</td>
										<th>Poznámka</th>
										<td colSpan={3}>
											<div>{caEvent && caEvent.eventDesc}</div>
										</td>
									</tr>
									</tbody>
									<thead>
									<tr>
										<th colSpan={11}>Ostatní veterinární úkony/vyšetření</th>
									</tr>
									</thead>
									<tbody>
									{printExams(examsPage, [vetExam, intExam])}
									<tr>
										<td colSpan={11}>&nbsp;</td>
									</tr>
									<tr>
										<td colSpan={11}>&nbsp;</td>
									</tr>
									</tbody>
								</table>
							</td>
						</tr>
						<tr>
							<td>
								<table cellPadding={0} cellSpacing={0} border={1}>
									<colgroup>
										<col width={'6.25%'}/>
										<col width={'12.5%'}/>
										<col width={'6.25%'}/>
										<col width={'12.5%'}/>
										<col width={'6.25%'}/>
										<col width={'12.5%'}/>
										<col width={'6.25%'}/>
										<col width={'12.5%'}/>
										<col width={'6.25%'}/>
										<col width={'18.75%'}/>
									</colgroup>
									<thead>
									<tr>
										<th colSpan={10}>Medikace a pokyny k ošetřování</th>
									</tr>
									</thead>
									<tbody>
									{printTreatments(treatmentsPage)}
									</tbody>
									<thead>
									<tr>
										<th colSpan={10}>Ostatní neveterinární úkony</th>
									</tr>
									</thead>
									<tbody>
									<tr>
										<th colSpan={2}>Datum vyřazení zvířete z boxu:</th>
										<td colSpan={8}>{boxEvents.map((event) => Date.formatDate(event.eventDate)).join(', ')}</td>
									</tr>
									<tr>
										<th colSpan={2}>Datum dezinfekce boxu:</th>
										<td colSpan={8}>{desEvents.map((event) => Date.formatDate(event.eventDate)).join(', ')}</td>
									</tr>
									</tbody>
								</table>
							</td>
						</tr>
						<tr>
							<td>
								<table cellPadding={0} cellSpacing={0} border={1}>
									<colgroup>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'31.25%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'31.25%'}/>
									</colgroup>
									<thead>
									<tr>
										<th colSpan={4}>Ošetření proti vnějším parazitům</th>
										<th colSpan={4}>Ošetření proti vnitřním parazitům</th>
									</tr>
									</thead>
									<tbody>
									{printEventsPar(eventsPage, enums)}
									</tbody>
								</table>
							</td>
						</tr>
						<tr>
							<td>
								<table cellPadding={0} cellSpacing={0} border={1}>
									<colgroup>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'6.25%'}/>
										<col width={'14%'}/>
										<col width={'14%'}/>
										<col width={'15.75%'}/>
										<col width={'6.25%'}/>
										<col width={'15.75%'}/>
										<col width={'7.85%'}/>
										<col width={'7.85%'}/>
									</colgroup>
									<thead>
									<tr>
										<th colSpan={10}>Vakcinace</th>
									</tr>
									</thead>
									<tbody>
									{printEventsVa(eventsPage, enums)}
									</tbody>
								</table>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</Modal.Body>

			<Modal.Footer>
				<Row>
					<Col sm={12}>
						<Button onClick={modal.onHide}>Storno</Button>
						<Button bsStyle="primary" onClick={window.print}><Glyphicon glyph="print"/> Vytisknout</Button>
					</Col>
				</Row>
			</Modal.Footer>
		</Modal>;
	}
}

DogPrintZK.propTypes = {
	dog: PropTypes.object.isRequired,
	intakesPage: PropTypes.object.isRequired,
	exitsPage: PropTypes.object.isRequired,
	examsPage: PropTypes.object.isRequired,
	eventsPage: PropTypes.object.isRequired,
	treatmentsPage: PropTypes.object.isRequired,
	enums: PropTypes.object.isRequired,
	modal: PropTypes.object.isRequired,
	session: PropTypes.object.isRequired
}

export default DogPrintZK



// WEBPACK FOOTER //
// ./src/components/dog/DogPrintZK.js